const api = '/api/trading.php';
import axios from 'axios';
export const tradingRepository =  {
    methods: {
        async get(item){
            return  axios.post(api,item);
        },
        async post(ids){
            return  axios.post(api, ids);
        },
    }
};

